import { PayloadAction } from '../../../store.model';
import {
    makePerformerRows,
    makeTeamRows,
} from '../focus-history/focus-history.function';
import {
    getSelectedBehaviourIdFromGrid,
    makeRows,
} from '../focus-selection/focus-selection.function';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { setupLoadGoalsState } from '../load-goals/load-goals.function';
import {
    defaultPerformerSortDefs,
    defaultTeamSortDefs,
} from '../model/focus-history.grid.model';

import {
    FocusSelectorSelectFocus,
    FocusSelectorSelectSubBehaviourRow,
} from './focus-selection.action';

export function focusSelectorSelectSubBehaviourRowReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectSubBehaviourRow>,
): FocusSelectorState {
    const { subBehaviourId } = action.payload;

    const updatedBehaviourRows = makeRows(
        state.behaviours,
        state.activeMetric.id,
        subBehaviourId,
        state.focusSelectionGrid?.filterByBehaviourId,
        state.focusSelectionGrid?.rows,
    );

    const selectedBehaviourId =
        getSelectedBehaviourIdFromGrid(updatedBehaviourRows);

    return {
        ...state,

        focusSelectionGrid: {
            ...state.focusSelectionGrid,
            rows: updatedBehaviourRows,
            sortDefs: [...state.focusSelectionGrid.sortDefs],
            selection: {
                ...state.focusSelectionGrid.selection,
                subBehaviourId,
                behaviourId: selectedBehaviourId,
            },
        },
    };
}

export function focusSelectorSelectFocusReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectFocus>,
): FocusSelectorState {
    const { focus } = action.payload;

    const updatedBehaviourRows = makeRows(
        state.behaviours,
        state.activeMetric.id,
        focus.subBehaviour.id,
    );

    const updatedActiveFocusesPerformerRows = makePerformerRows(
        state.activeFocusesForPerformer,
    );
    const updatedClosedFocusesPerformerRows = makePerformerRows(
        state.recentlyClosedFocusesForPerformer,
    );
    const updatedActiveFocusesTeamRows = makeTeamRows(
        state.activeFocusesForTeam,
    );
    const updatedClosedFocusesTeamRows = makeTeamRows(
        state.recentlyClosedFocusesForTeam,
    );

    const { goals, loadGoalsGrid, selectedGoals, updatedGoalsCollection } =
        setupLoadGoalsState(
            state.activeMetric,
            focus,
            state.coachableMetrics,
            state.behaviours,
            state.initSelectedMetricIds,
            state.goalsCollection,
            state.loadGoalsGrid,
        );

    return {
        ...state,

        goals,
        selectedFocus: focus,
        selectedGoals,

        goalsCollection: updatedGoalsCollection,

        focusSelectionGrid: {
            ...state.focusSelectionGrid,
            rows: updatedBehaviourRows,
            sortDefs: [...state.focusSelectionGrid.sortDefs],
            filterByBehaviourId: null,
            selection: {
                behaviourId: focus.behaviour.id,
                subBehaviourId: focus.subBehaviour.id,
            },
        },

        activeFocusesPerformerGrid: {
            ...state.activeFocusesPerformerGrid,
            rows: updatedActiveFocusesPerformerRows,
            sortDefs: [...defaultPerformerSortDefs],
            selection: null,
        },

        recentlyClosedFocusesPerformerGrid: {
            ...state.recentlyClosedFocusesPerformerGrid,
            rows: updatedClosedFocusesPerformerRows,
            sortDefs: [...defaultPerformerSortDefs],
            selection: null,
        },

        activeFocusesTeamGrid: {
            ...state.activeFocusesTeamGrid,
            rows: updatedActiveFocusesTeamRows,
            sortDefs: [...defaultTeamSortDefs],
            selection: null,
        },

        recentlyClosedFocusesTeamGrid: {
            ...state.recentlyClosedFocusesTeamGrid,
            rows: updatedClosedFocusesTeamRows,
            sortDefs: [...defaultTeamSortDefs],
            selection: null,
        },

        loadGoalsGrid,
    };
}
